module.exports = __webpack_public_path__ + "img/sus_commityed_to_sustainability.02731a60.png";